import { createAction, createReducer } from 'redux-act'

// Default State
export const buttons = {
    new: 'new',
    save: 'save',
    remix: 'remix',
    info: 'info',
    tweet: 'tweet'
}

const defaultState = {
    disabled: {
        [buttons.new]: false,
        [buttons.save]: true,
        [buttons.remix]: false,
        [buttons.info]: false,
        [buttons.tweet]: true
    }
}

// Action Creators
export const actions = {
    enableButton: createAction('Enables a button', button => ({ button })),
    disableButton: createAction('Disables a button', button => ({ button }))
}

// Reducer
export default createReducer(
    {
        [actions.enableButton]: (state, { button }) => ({
            ...state,
            disabled: {
                ...state.disabled,
                [button]: false
            }
        }),

        [actions.disableButton]: (state, { button }) => ({
            ...state,
            disabled: {
                ...state.disabled,
                [button]: true
            }
        })
    },
    defaultState
)

// Selectors
export const selectors = {
    isButtonDisabled: ({ disabled }) => {
        return button => disabled[button]
    }
}



// WEBPACK FOOTER //
// ./src/ducks/navigation.js